import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleRight,
    faClock,
    faLocationDot,
} from '@fortawesome/free-solid-svg-icons';

function EventsCard({
    id,
    name,
    img,
    organizer,
    location,
    start_time,
}) {

    return (
        <Link key={id} id="events-card" to={`/events/${id}`}>
            <div id="events-card-img">
                <img src={img} alt="événement" />
            </div>
            <div id="events-card-content">
                <div id="events-card-author">{organizer.last_name}</div>
                <div id="events-card-title">{name}</div>
                <div id="events-card-supp">
                    <FontAwesomeIcon icon={faClock} /> {start_time}{' '}
                    • <FontAwesomeIcon icon={faLocationDot} />{' '}
                    {location.slice(0, 35)}{location.length > 35 ? '...' : ''}
                </div>
            </div>
            <div id="events-card-icon">
                <FontAwesomeIcon icon={faAngleRight} size="xl" />
            </div>
        </Link>
    );
}

// Prop types for the EventsCard component
EventsCard.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    organizer: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    start_time: PropTypes.string.isRequired,
};

export default EventsCard;
